import { createElement, forwardRef, memo } from 'react'
import { usePress } from '@react-aria/interactions'

import type { PressableProps } from './types'

/**
 * Базовый примитив интерактива продукта.
 * Ставит data-pressed от usePress (react-aria сам отменяет нажатие при скролле),
 * не использует onClick/:active. Тег рендера динамический — используем createElement,
 * чтобы не биться со строгой типизацией JSX для полиморфного тега.
 */
export const Pressable = memo(
  forwardRef<HTMLElement, PressableProps>(function Pressable(props, ref) {
    const {
      as = 'div',
      onPress,
      isDisabled = false,
      children,
      ariaLabel,
      role,
      tabIndex,
      id,
      type,
    } = props

    const { pressProps, isPressed } = usePress({ onPress, isDisabled })

    return createElement(
      as,
      {
        ref,
        id,
        role,
        'aria-label': ariaLabel,
        'aria-disabled': isDisabled || undefined,
        tabIndex: isDisabled ? -1 : tabIndex,
        'data-pressed': isPressed,
        type: as === 'button' ? (type ?? 'button') : undefined,
        ...pressProps,
      },
      children,
    )
  }),
)
